import React, { useEffect, useState } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { fetchApi } from '../../services/api';
import JsonPretty from '../../components/JsonPretty';
import { ViewModel as HistoryResponse } from 'TypeGen/Quote/Rules/History/view-model';
import { EntryViewModel } from 'TypeGen/Quote/Rules/History/entry-view-model';
import dayjs from 'dayjs';

type Props = {
  ruleId: number | null;   // null = all rules
  title: string;
  onClose: () => void;
};

const CHANGE_COLOR: Record<string, string> = {
  Created: '#0E7C7B', Updated: '#1355A2', Deleted: '#E85D26',
  Reordered: '#D4860C', Enabled: '#0E7C7B', Disabled: '#5C6B7A',
};

const RuleHistory: React.FC<Props> = ({ ruleId, title, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [entries, setEntries] = useState<EntryViewModel[]>([]);

  useEffect(() => {
    fetchApi('/api/QuoteRules/History' + (ruleId != null ? `?ruleId=${ruleId}` : ''))
      .then((r: HistoryResponse) => setEntries(r.Entries))
      .finally(() => setLoading(false));
  }, [ruleId]);

  return (
    <Dialog title={title} onClose={onClose} className='dialog-w800'>
      {loading && <span className="k-i-loading k-icon" style={{ fontSize: 28 }} />}
      {!loading && entries.length === 0 && <p className="text-muted">No history yet.</p>}
      {!loading && entries.map((e, i) => (
        <div key={i} className="border-bottom" style={{ padding: '10px 4px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              <span style={{
                fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em',
                color: CHANGE_COLOR[e.ChangeType] ?? '#8A97A4', background: (CHANGE_COLOR[e.ChangeType] ?? '#8A97A4') + '22',
                padding: '2px 7px', borderRadius: 5, marginRight: 8,
              }}>{e.ChangeType}</span>
              <b>{e.RuleName}</b>
            </span>
            <span className="text-muted small">
              {dayjs.utc(e.ChangedDateTime).local().format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </div>
          <div className="text-muted small mt-1">
            by {e.ChangedByName || 'Unknown'}
          </div>
          {(e.OldValues || e.NewValues) && (
            <details className="mt-1">
              <summary className="text-primary small" style={{ cursor: 'pointer' }}>View change</summary>
              <div className="row mt-1">
                {e.OldValues && (
                  <div className="col">
                    <label className="text-muted small mb-0">Old</label>
                    <JsonPretty json={e.OldValues} />
                  </div>
                )}
                {e.NewValues && (
                  <div className="col">
                    <label className="text-muted small mb-0">New</label>
                    <JsonPretty json={e.NewValues} />
                  </div>
                )}
              </div>
            </details>
          )}
        </div>
      ))}
    </Dialog>
  );
};

export default RuleHistory;
